module.exports = __webpack_public_path__ + "img/hc3620_center_001.499c0a7c.png";